import type { Box } from "../types/spatial/Box"
import type { SpatialRectangle } from "../types/spatial/SpatialRectangle"
import type { Measure } from "../types/Units"

export const BoxToRectangle = <T extends Measure>([
  x,
  y,
  x2,
  y2,
]: Box<T>): SpatialRectangle<T> => ({
  height: (y2 - y) as T,
  width: (x2 - x) as T,
  x,
  y,
})
